<template>
  <div id="loginSection">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="card">
            <form onsubmit="event.preventDefault()" class="box">
              <h1>ورود</h1>
              <p class="text-muted">لطفا رمز عبور و پسورد خود را وارد کنید</p>
              <input type="text" v-model="username" placeholder="نام کاربری" />
              <input
                type="password"
                v-model="password"
                placeholder="رمز عبور"
              />
              <button :class="{disableButton:disabledLoginBtn}" id="loginBtn" @click="login()">ورود</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
      metaInfo() {
    return {
      title: " ورود",
    }
  },
  data() {
    return {
      username: null,
      password: null,
      disabledLoginBtn: false,
      current_url: "/admin/login",
    };
  },
  methods: {
    login() {
      let form_data = new FormData();
      form_data.append("username", this.username);
      form_data.append("password", this.password);
      this.disabledLoginBtn = true;
      this.$axios
        .post( this.current_url,form_data)
        .then((response) => {
          this.disabledLoginBtn = false;
          this.$cookie.set("adminAuthorization","Bearer "+response.data.data.token,1);
          this.$axios.defaults.headers.common['Authorization'] ="Bearer "+response.data.data.token;
          this.$root.isLogin = true;
          localStorage.setItem("username",this.username)
          this.$router.push("/admin/dashboard");
        })
        .catch((err) => {
          this.disabledLoginBtn = false;
          window.swal({
                icon: "warning",
                showConfirmButton: true,
                text: "نام کاربری یا رمز عبور شما اشتباه است",
                button: "باشه",
              });
        });
    },
  },
};
</script>
<style scoped>
#loginSection {
  background: linear-gradient(to right, #b92b27, #1565c0);
  height: 100vh;
}

.card {
  margin-bottom: 20px;
  border: none;
}

.box {
  width: 500px;
  padding: 40px;
  position: absolute;
  top: 50%;
  left: -40%;
  background: #191919;
  text-align: center;
  transition: 0.25s;
  margin-top: 100px;
  box-shadow: 10px 9px 12px black;
}

.box input[type="text"],
.box input[type="password"] {
  border: 0;
  background: none;
  display: block;
  margin: 20px auto;
  text-align: center;
  border: 2px solid #3498db;
  padding: 10px 10px;
  width: 250px;
  outline: none;
  color: white;
  border-radius: 24px;
  direction: ltr;
  transition: 0.25s;
}

.box h1 {
  color: white;
  text-transform: uppercase;
  font-weight: 500;
}

.box input[type="text"]:focus,
.box input[type="password"]:focus {
  width: 300px;
  border-color: #2ecc71;
}

#loginBtn {
  border: 0;
  background: none;
  display: block;
  margin: 20px auto;
  text-align: center;
  border: 2px solid #2ecc71;
  padding: 14px 40px;
  outline: none;
  color: white;
  border-radius: 24px;
  transition: 0.25s;
  cursor: pointer;
}

.box input[type="submit"]:hover {
  background: #2ecc71;
}

.forgot {
  text-decoration: underline;
}

ul.social-network {
  list-style: none;
  display: inline;
  margin-left: 0 !important;
  padding: 0;
}

ul.social-network li {
  display: inline;
  margin: 0 5px;
}

.social-network a.icoFacebook:hover {
  background-color: #3b5998;
}

.social-network a.icoTwitter:hover {
  background-color: #33ccff;
}

.social-network a.icoGoogle:hover {
  background-color: #bd3518;
}

.social-network a.icoFacebook:hover i,
.social-network a.icoTwitter:hover i,
.social-network a.icoGoogle:hover i {
  color: #fff;
}

a.socialIcon:hover,
.socialHoverClass {
  color: #44bcdd;
}

.social-circle li a {
  display: inline-block;
  position: relative;
  margin: 0 auto 0 auto;
  border-radius: 50%;
  text-align: center;
  width: 50px;
  height: 50px;
  font-size: 20px;
}

.social-circle li i {
  margin: 0;
  line-height: 50px;
  text-align: center;
}

.social-circle li a:hover i,
.triggeredHover {
  transform: rotate(360deg);
  transition: all 0.2s;
}

.social-circle i {
  color: #fff;
  transition: all 0.8s;
  transition: all 0.8s;
}
</style>
<style >
    .disableButton{
        pointer-events: none;
        cursor: not-allowed;
        opacity: 0.5;
    }
</style>